module.exports = __webpack_public_path__ + "img/rheinland-pfalz.581b4f6.webp";